export enum AuthActionTypes {
	API_RESPONSE_SUCCESS = '@@auth/API_RESPONSE_SUCCESS',
	API_RESPONSE_ERROR = '@@auth/API_RESPONSE_ERROR',

	LOGIN_USER = '@@auth/LOGIN_USER',
	LOGIN_Requires_TwoFactor = '@@auth/LOGIN_Requires_TwoFactor',
	LOGIN_USER_SOCIALMEDIA = '@@auth/LOGIN_USER_SOCIALMEDIA',
	LOGOUT_USER = '@@auth/LOGOUT_USER',
	SIGNUP_USER = '@@auth/SIGNUP_USER',
	FORGOT_PASSWORD = '@@auth/FORGOT_PASSWORD',
	FORGOT_PASSWORD_CHANGE = '@@auth/FORGOT_PASSWORD_CHANGE',
	RESET_PASSWORD = '@@auth/RESET_PASSWORD',
	CONFIRM_MAIL = '@@auth/CONFIRM_MAIL',
	FETCH_USER_PROFILE = '@@auth/FETCH_USER_PROFILE',
	FETCH_USER_PERMISSION = '@@auth/FETCH_USER_PERMISSION',
	FETCH_TENANT_SUBSCRIPTION_PLAN = '@@auth/FETCH_TENANT_SUBSCRIPTION_PLAN',
	HYDRATE_AUTH_SESSION = '@@auth/HYDRATE_AUTH_SESSION',
	VERIFY_TWO_FACTOR = '@@auth/VERIFY_TWO_FACTOR',
	REQUEST_TWO_FACTOR_EMAIL_CODE = '@@auth/REQUEST_TWO_FACTOR_EMAIL_CODE',

	RESET = '@@auth/RESET',
}
